import Module2ClassificationComponent from './module2';

// Use the refactored component that now has full functionality
const Module2Classification = Module2ClassificationComponent;
export default Module2Classification;
